//---------------------------------------------------------------------
// React, MUI, and other third-party modules imports
//---------------------------------------------------------------------
import React, { useEffect, useRef } from 'react';
// import { useState, useEffect, useContext, useCallback } from 'react';
import { makeStyles, Grid, useTheme, useMediaQuery } from '@material-ui/core';
// import ThumbUpAltIcon from '@material-ui/icons/ThumbUpAlt';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
// import SimpleBar from 'simplebar-react';
import CloseIcon from '@material-ui/icons/Close';

//---------------------------------------------------------------------
// Common helpers and constants imports
//---------------------------------------------------------------------
import { logPageView } from '../../system/firebase';

// import { unsubscribeRealtimeUpdates } from '../../system/firebase';
// import { LayoutContext, AppContext } from '../../common/contexts';
import { setClassNameInDefns } from '../../common/definitionHelper';
import { PAGE_TITLE_RESOURCE_CENTER } from '../../common/constants';
import { getCopyrightText } from '../../common/textHelper';
import { AFITD_DOMAIN, PATH_RESOURCE_CENTER } from '../../system/constants';

//---------------------------------------------------------------------
// Page specific helpers and constants imports
//---------------------------------------------------------------------
import bannerImg from '../../images/ResourceCenter/Article 4 Main Image.jpeg';
import bannerLogo from '../../images/ResourceCenter/article1Logo/afitd_primary_logo-01.svg';
import DedicatedLogo from '../../images/ResourceCenter/article4Logo/Dedicated.png';
import WorkLogo from '../../images/ResourceCenter/article4Logo/Work.png';
import { useHistory } from 'react-router-dom';

// import cardImg1 from '../../images/FAQ/Rectangle 202.png';
// import cardImg2 from '../../images/FAQ/Rectangle 2021.png';
// import cardImg3 from '../../images/FAQ/Rectangle 2022.png';
// import shareImg1 from '../../images/FAQ/Vector1.png';
// import shareImg2 from '../../images/FAQ/Vector2 (1).png';
// import shareImg3 from '../../images/FAQ/Vector3 (1).png';
// import shareImg4 from '../../images/FAQ/Ic_copy link.png';

//---------------------------------------------------------------------
// Common components imports
//---------------------------------------------------------------------
import AfitdPageHead from '../../common/elemental/AfitdPageHead';
// import AfitdTypography from '../../common/elemental/AfitdTypography';

//---------------------------------------------------------------------
// Page specific components imports
//---------------------------------------------------------------------
// import SubComponent1Example from './SubComponent1Example';

//---------------------------------------------------------------------
// Utilities (clsx, lodash, date-fns, etc.) imports
//---------------------------------------------------------------------
// import cx from 'clsx';
// import _get from 'lodash/get';

//---------------------------------------------------------------------
// CSS
//---------------------------------------------------------------------
const useStyles = makeStyles(theme => ({
    root: {
        // '&::-webkit-scrollbar-track': {
        //     borderRadius: '10px',
        //     background: 'none',
        // },
        // '&::-webkit-scrollbar': {
        //     width: '8px',
        //     backgroundColor: '#F5F5F5',
        // },
        // '&::-webkit-scrollbar-thumb': {
        //     borderRadius: '10px',
        //     backgroundColor: 'rgba(0,0,0,0.2)',
        // },
    },
    topText: { fontWeight: 700, fontSize: '16px', lineHeight: '19px', color: '#111E14', textAlign: 'center' },
    heading: {
        color: '#21898A',
        fontWeight: 700,
        fontSize: '42px',
        lineHeight: '52px',
        textAlign: 'center',
        maxWidth: '700px',
        margin: 'auto',
        [theme.breakpoints.down('sm')]: { fontSize: 26, lineHeight: '34px' },
    },
    bannerImg: { textAlign: 'center', marginTop: '45px', marginBottom: '40px' },
    paragraph: {
        fontSize: '20px',
        fontWeight: 400,
        lineHeight: '36px',
        maxWidth: '730px',
        margin: 'auto',
        [theme.breakpoints.down('sm')]: { fontSize: '18px', lineHeight: '32px' },
    },
    questionTitle: {
        fontSize: '22px',
        fontWeight: 'bold',
        lineHeight: '36px',
        maxWidth: '730px',
        margin: 'auto',
        [theme.breakpoints.down('sm')]: { fontSize: '18px', lineHeight: '32px' },
    },
    secondaryHeader: {
        color: '#21898A',
        fontSize: '26px',
        fontWeight: '700',
        lineHeight: '30px',
        marginTop: '70px',
        maxWidth: '730px',
        // margin: 'auto',
        marginBottom: '24px',
        [theme.breakpoints.down('sm')]: { fontSize: 22, lineHeight: '25px' },
    },
    social: { maxWidth: '730px', margin: 'auto', marginTop: '50px', display: 'flex', alignItems: 'center', marginBottom: '30px' },
    iconContainer: {
        width: '60px',
        height: '60px',
        borderRadius: '50%',
        backgroundColor: 'rgba(252, 130, 31, 0.13)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    socialText: { fontSize: '16px', fontWeight: 700, lineHeight: '19px', paddingLeft: '16px' },
    hr: { backgroundColor: '#F0F2F6', margin: 'auto', marginTop: 50, maxWidth: '840px' },
    navigations: { display: 'flex', justifyContent: 'space-between', maxWidth: '1100px', margin: 'auto', marginTop: '20px' },
    navigationIconContainer: {
        display: 'flex',
        width: '40px',
        height: '40px',
        borderRadius: '50%',
        border: '1px solid #D5D7DD',
        justifyContent: 'center',
        alignItems: 'center',
        '&:hover': { cursor: 'pointer' },
    },
    navigationText: { padding: '0 16px', fontSize: '20', width: '500', fontWeight: 'bold' },
    navigationButtonContainer: { display: 'flex', alignItems: 'center' },
    card: { width: '352px', borderRadius: '8px', border: '1px solid #D5D7DD', '&:hover': { cursor: 'pointer' } },
    cardContainer: { marginTop: '60px', marginBottom: 60 },
    cardContent: { marginBottom: '27px', marginLeft: '24px', marginRight: '20px', borderBottom: '20px solid #fafafc' },
    cardHeading: { fontSize: '26px', fontWeight: 'bold', lineHeight: '34px' },
    cardParagraph: { fontSize: '15px', fontWeight: 400, lineHeight: '24px' },
    cardSocial: { display: 'flex', alignItems: 'center', marginTop: '20px' },
    cardSocialText: { marginLeft: '9px', fontSize: '14px', lineHeight: '16px', fontWeight: 400 },
    cardSection: { display: 'flex', alignItems: 'flex-start', justifyContent: 'center' },
    dateTime: { marginBottom: 0, marginTop: '24px', fontSize: '14px', lineHeight: '16px', fontWeight: 400 },
    shareImageContainer: { textAlign: 'center', marginBottom: '16px', position: 'relative', '&:hover': { cursor: 'pointer' }, [theme.breakpoints.down('sm')]: { marginRight: 10 } },
    shareContainer: { display: 'flex', flexDirection: 'column', marginLeft: '-75px', [theme.breakpoints.down('sm')]: { flexDirection: 'row', marginLeft: 0, marginTop: 50 } },
    shareContainer2: { display: 'flex', flexDirection: 'column', position: 'absolute', top: 0, right: 25, [theme.breakpoints.only('md')]: { top: 360, right: 10 } },
    paragraphContainer: {
        // height: 500,
        [theme.breakpoints.only('md')]: { paddingRight: 30 },
        position: 'relative',
        // overflowY: 'scroll',
        // '&::-webkit-scrollbar-track': {
        //     borderRadius: '10px',
        //     background: 'none',
        // },
        // '&::-webkit-scrollbar': {
        //     width: '8px',
        //     backgroundColor: '#F5F5F5',
        // },
        // '&::-webkit-scrollbar-thumb': {
        //     borderRadius: '10px',
        //     backgroundColor: 'rgba(0,0,0,0.2)',
        // },
    },
    img: { width: '100%' },
    imgLogo: { display: 'flex', maxWidth: 275, zIndex: 1, marginTop: '-47px' },
    tableContainer: { border: '1px solid black', width: '100%', borderCollapse: 'collapse' },
    tableRow: { border: '1px solid black', padding: '5px 10px 10px 10px' },
    tableRowName: { border: '1px solid black', padding: '5px 10px 10px 10px', color: '#21898A', width: 170, fontWeight: 'bold' },
    skillTitle: { color: '#21898A', textDecoration: 'underline', fontWeight: 'bold' },
    skillContainer: { display: 'flex', justifyContent: 'space-around' },
    leftLogo: { width: 90, height: 90 },
    logoHeaderContainer: {
        display: 'flex',
        marginLeft: '121px',
        marginTop: '10px',
        marginBottom: '10px',
        alignItems: 'flex-end',
        [theme.breakpoints.down('md')]: { maxWidth: 730, margin: '0 auto' },
        [theme.breakpoints.down('sm')]: { marginLeft: 0 },
    },
    closeIconContainer: { display: 'flex', justifyContent: 'flex-end', marginTop: '-30px' },
    closeIcon: { color: '#A4A6A5' },
    backToTopContainer: { display: 'flex', justifyContent: 'flex-end', maxWidth: '905px' },
    backToTopText: {
        textDecoration: 'underline',
        color: '#1DA98E',
        fontStyle: 'italic',
        cursor: 'pointer',
        fontWeight: 'bold',
        fontSize: 18,
        [theme.breakpoints.down('sm')]: {
            fontSize: '14px',
        },
    },
    flexSpaceBetween: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        width: '100%',
    },
    copyRightText: {
        marginLeft: theme.spacing(20),
        fontSize: '18px',
        fontWeight: 'bold',
        [theme.breakpoints.down('sm')]: {
            marginLeft: '0px',
            fontSize: '14px',
            maxWidth: '220px',
        },
    },
}));

//---------------------------------------------------------------------
// Get definitions
//---------------------------------------------------------------------
const getDefns = params => {
    const { classes, handleCloseIcon } = params;

    const defns = {
        icon: { fontSize: '30px', color: '#FC821F', opacity: 1 },
        navIconLeft: { marginLeft: '10px' },
        navIconRight: { marginLeft: '3px' },
        cardContainer: { container: true, spacing: 5 },
        cardSection: { item: true, lg: 4, md: 6, sm: 12, xs: 12 },
        cardIcon: { color: 'rgba(17, 30, 20, 0.4)' },
        pageContent: { container: true },
        paragraphContainer: { item: true, lg: 12, md: 12, sm: 12, xs: 12 },
        shareContainer: { item: true, lg: 0, md: 0, sm: 12, xs: 12 },
        closeIcon: { onClick: handleCloseIcon },
        gallopText: { target: '_blank', href: 'https://news.gallup.com/poll/329501/majority-workers-continue-punch-virtually.aspx' },
        studiesLink: { target: '_blank', href: 'https://www.healthline.com/health/healthy-home-guide/benefits-of-indoor-plants' },
        trueLink: { target: '_blank', href: 'https://miadanielle.com/psychological-effects-of-clutter/' },
        handyGuideLink: { target: '_blank', href: 'https://iamautonomous.medium.com/guide-to-choosing-the-best-office-chair-suits-you-at-home-986c3e68ab0' },
        theySayLink: { target: '_blank', href: 'https://www.mayoclinic.org/healthy-lifestyle/adult-health/expert-answers/sitting/faq-20058005' },
        resourceCenterText: { target: '_blank', href: '/resource-center' },
    };

    // Automatically inject className for matching keys
    setClassNameInDefns(defns, classes);

    return defns;
};

//---------------------------------------------------------------------
// Helper functions
//---------------------------------------------------------------------

//---------------------------------------------------------------------
// Component
//---------------------------------------------------------------------
const ArticleFour = props => {
    //---------------------------------------------------------------------
    // From context and other hooks
    //---------------------------------------------------------------------
    const classes = useStyles();
    const theme = useTheme();
    // const matchesMd = useMediaQuery(theme.breakpoints.down('md'));
    const matchesSm = useMediaQuery(theme.breakpoints.down('sm'));
    const history = useHistory();
    const myRef = useRef(null);

    // const appContext = useContext(AppContext);
    // const { currentUser, userId, profileData, currentEmployer, employerId, lovs } = appContext;

    // const layoutContext = useContext(LayoutContext);
    // const { setSnackbarMessage, setSnackbarErrorMessage } = layoutContext;

    //---------------------------------------------------------------------
    // From props
    //---------------------------------------------------------------------
    // const { propExample } = props;

    //---------------------------------------------------------------------
    // Local states
    //---------------------------------------------------------------------
    // const [isDirty, setIsDirty] = useState(false);

    //---------------------------------------------------------------------
    // Derived
    //---------------------------------------------------------------------
    const pageTitle = `Working from Home: Where Productivity meets Balance | ${PAGE_TITLE_RESOURCE_CENTER}`;
    const pageTitleSeo = 'Working from Home: Where Productivity meets Balance';

    //---------------------------------------------------------------------
    // Side effects
    //---------------------------------------------------------------------
    useEffect(() => {
        logPageView(pageTitle);
    }, [pageTitle]);

    //---------------------------------------------------------------------
    // useCallback / Event handlers
    //---------------------------------------------------------------------
    const handleNextButton = () => {
        history.push('/resource-center/5');
    };
    const handlePreviousButton = () => {
        history.push('/resource-center/3');
    };
    const handleCloseIcon = () => {
        history.push('/resource-center');
    };
    //---------------------------------------------------------------------
    // Definitions
    //---------------------------------------------------------------------
    const defns = getDefns({ classes, props, handleCloseIcon });

    //---------------------------------------------------------------------
    // Render
    //---------------------------------------------------------------------
    return (
        <div {...defns.root}>
            <AfitdPageHead
                title={pageTitleSeo}
                description="Working from home has become an increasingly popular option for many in a post-pandemic world working remotely. It can provide a range of benefits and more!"
                keywords="working from home, work from home, post-pandemic world, pandemic and the world"
                canonicalUrl={`https://${AFITD_DOMAIN}${PATH_RESOURCE_CENTER}/4`}
            />
            <div ref={myRef} />
            <p {...defns.topText}>8 min read</p>
            <div {...defns.closeIconContainer}>
                <CloseIcon {...defns.closeIcon} />
            </div>
            <h1 {...defns.heading}>
                Working from Home:
                <br />
                Where Productivity meets Balance
            </h1>
            <div {...defns.navigations}>
                <div {...defns.navigationButtonContainer} onClick={handlePreviousButton}>
                    <div {...defns.navigationIconContainer}>
                        <ArrowBackIosIcon style={{ ...defns.navIconLeft }} />
                    </div>
                    <span {...defns.navigationText}>Previous</span>
                </div>
                <div {...defns.navigationButtonContainer} onClick={handleNextButton}>
                    <span {...defns.navigationText}>Next</span>
                    <div {...defns.navigationIconContainer}>
                        <ArrowForwardIosIcon style={{ ...defns.navIconRight }} />
                    </div>
                </div>
            </div>

            <div {...defns.bannerImg}>
                <img {...defns.img} src={bannerImg} alt="" />
                <img {...defns.imgLogo} src={bannerLogo} alt="" />
            </div>

            <Grid {...defns.pageContent}>
                {matchesSm ? (
                    <>
                        <Grid {...defns.paragraphContainer}>
                            <div style={{ height: '100%' }} autoHide={false}>
                                <p {...defns.paragraph}>
                                    Working remotely will most likely be a part of the new normal in a post-pandemic world. There are many benefits to telework, but there are also
                                    a few downsides. With a little bit of prep work, you can ensure that if you’re fortunate enough to work remotely, even on a part-time basis,
                                    that you set yourself up for success at home.
                                </p>
                                <div {...defns.logoHeaderContainer}>
                                    <img {...defns.leftLogo} src={DedicatedLogo} alt="" />
                                    <h2 {...defns.secondaryHeader}>Dedicated Workspace</h2>
                                </div>
                                <p {...defns.paragraph}>
                                    Ideally, it would be great to dedicate an entire room as a work from home space, but we know that isn’t an option for all. We’re going to give
                                    you the best tips for setting up a dedicated workspace even if that space is your living room coffee table.
                                </p>
                                <br />
                                <p {...defns.paragraph}>
                                    <span style={{ fontStyle: 'italic' }}>
                                        Before getting started, we want to remind you to keep in mind that some companies have specific requirements attached to their work from
                                        home programs such as having a desk space and desk chair. Be sure to check with your company before setting up your space to ensure that you
                                        check all their telework boxes.
                                    </span>
                                </p>
                                <br />
                                <p {...defns.paragraph}>
                                    <span style={{ fontWeight: 'bold' }}> Stay Out of the Bedroom: </span>
                                    If possible, try not to make your dedicated space your bedroom. A workspace is generally a space where your mind is at it’s sharpest and most
                                    creative. Working in the bedroom can lead to interrupted sleep patterns because your brain will be wired to work mode when in it’s that space.
                                    Instead of counting sheep, you’ll be counting unfinished tasks and then the next morning you’ll be counting how much sleep you got on one hand.
                                    Not a good situation to be in. Bedrooms should be reserved for two things: sleeping and...well, use your imagination.
                                </p>
                                <br />
                                <p {...defns.paragraph}>
                                    <span style={{ fontWeight: 'bold' }}> Incorporate Triggers: </span>
                                    This is especially important if you’ll be working at the dining room table, kitchen counter, or coffee table. There has to be certain elements
                                    present that trigger your brain into knowing that it’s time to be productive for it to differentiate how it feels when you’re living in that
                                    space any other time. A few ideas could be:
                                    <ul>
                                        <li>
                                            Designate a specific coffee cup or water bottle for work. Don’t use it at any other time. When you fill’er up the creative juices will
                                            start to flow.
                                        </li>
                                        <li>
                                            Purchase a lap desk or tabletop desk to be used only during work time. That will set the tone for productivity at the beginning of the
                                            day.
                                        </li>
                                        <li>
                                            Pick a specific work scent, like an essential oil or a lovely candle.Fill a diffuser or light the candle at the start of your workday,
                                            and of course don’t use those scents during non-work hours (hopefully you can see by now that not using the trigger when not working is
                                            a pattern we’re going for here).
                                        </li>
                                    </ul>
                                </p>
                                <br />
                                <p {...defns.paragraph}>
                                    <span style={{ fontWeight: 'bold' }}>Inspirational Décor: </span>
                                    Creativity is born through inspiration. To really get the creative energy flowing within your workspace consider incorporating elements that are
                                    inspirational to you. This could be a painting, a motivational poster, pictures of your family, awards you’re proud of, sentimental gifts,
                                    heirlooms, and the list goes on. <br /> <br />
                                    Live plants are also phenomenal in a workspace (or in the home in general). Not only do <a {...defns.studiesLink}>studies</a> show that live
                                    plants in the home increases happiness, but they also keep the air cleaner, reduce stress levels, and boost productivity. They are also quite
                                    pretty to look at and will make your space more aesthetically pleasing.
                                </p>
                                <br />
                                <p {...defns.paragraph}>
                                    <span style={{ fontWeight: 'bold' }}>Keep it Tidy: </span>
                                    Try to keep your space organized and tidy. Have you ever heard the saying, “cluttered space, cluttered mind?” Well, it’s{' '}
                                    <a {...defns.trueLink}>true</a>. When your living or working space is organized, your thoughts and mind are more organized leading to less
                                    stress and anxiety, and sharper focus.
                                </p>
                                <br />
                                <p {...defns.paragraph}>
                                    <span style={{ fontWeight: 'bold' }}>Let there be Light: </span>
                                    Having proper lighting is essential in a healthy workspace. Good lighting is a mood booster, while prolonged exposure to poor lighting has been
                                    shown to increase or cause depression. Good lighting is also beneficial to reducing eye strain, which is crazy important when half our lives are
                                    spent staring at screens these days. Natural light is always best so set up shop near a window if that’s an option for you. If not, artificial
                                    lighting can do the trick too. Whatever the case make your space bright and happy.
                                </p>
                                <br />
                                <p {...defns.paragraph}>
                                    <span style={{ fontWeight: 'bold' }}>Let there be Light: </span>
                                    Sit on It (but not too long): Having a comfortable and sturdy chair for work is essential to the overall health of your entire body. Sitting in
                                    an inadequate chair for extended periods of time can lead to all kinds of chaos from back pain to headaches to fatigue, even sciatica...the list
                                    is crazy long, ya’ll. You’ll want to do a smidge of research to find the chair that is best for your needs and we found this{' '}
                                    <a {...defns.handyGuideLink}>handy guide over on Medium</a> to get you started.
                                    <br /> <br />
                                    While sitting correctly is important, do you know what’s even more important? <strong> Standing.</strong> Yes, we’re talking about the opposite
                                    of sitting now, but standing is one of the number one things you should be doing at home. <a {...defns.theySayLink}>They say</a> that sitting is
                                    the new smoking, and while that might seem a tad dramatic, they aren’t wrong. Sitting for too long can lead to blood clots, increased blood
                                    pressure and cholesterol, weight gain and other health issues. At a minimum try to stand up for a few minutes every hour, but every 30 minutes
                                    is even better. You can walk and talk on the phone or if you have the means and the space, maybe even consider a standing desk.
                                </p>

                                <div {...defns.logoHeaderContainer}>
                                    <img {...defns.leftLogo} src={WorkLogo} alt="" />
                                    <h2 {...defns.secondaryHeader}>Work/Life Balance</h2>
                                </div>
                                <p {...defns.paragraph}>
                                    These are a few of our go-to tips to make sure that when we’re working from home, we are keeping balance between what should be work and what
                                    should be home: <br />
                                    <ul>
                                        <li>
                                            <strong>Take Breaks: </strong> Just like when you’re physically in the office you are legally allowed breaks (usually two 15-minute
                                            breaks and a 30-minute lunch break, but check with your company for their guidelines).
                                        </li>
                                        <li>
                                            <strong>Get Outside: </strong> If you’re able to go outside and breathe in some sweet fresh air and soak up a little Vitamin D, you so
                                            should. Maybe take a quick walk during one of your breaks if that’s a possibility for you. Fresh air and sunshine is the ultimate stress
                                            reducer.
                                        </li>
                                        <li>
                                            <strong>Stay Hydrated: </strong> This is just good advice for always, but make sure you’re getting in the H20 during business hours for
                                            sure. Being hydrated helps your body perform at optimal levels and reduces fatigue (plus all the other benefits of water, a.k.a. the
                                            elixir of life).
                                        </li>
                                        <li>
                                            <strong>Take back Your Time: </strong> Working from home gives you back those hours of life you would normally spend commuting to and
                                            from the office. Take advantage of that precious time and do something awesome for yourself. Take that spin class that never fit into
                                            your schedule before or get a killer home workout in. Sleep in a little bit (if it won’t mess up your sleep cycle), finish reading a
                                            book, or take your dog/kids/both to the park...whatever it is that makes you feel more relaxed, more alive, more present...do that and
                                            enjoy it.
                                        </li>
                                        <li>
                                            <strong>Leave Work at Work: </strong> Just like when you’re in the office, it’s imperative to leave work at work. This can be tricky
                                            when working from home, but if you follow our tips for setting up your workspace that should make it a little easier. For your mental
                                            and physical health there needs to be a moment when you break up with your workday every day. This is similar to how we set triggers for
                                            beginning our workday. A few tricks that might work for you:
                                        </li>
                                        <ul style={{ listStyle: 'disc' }}>
                                            <li>Shut down your computer. When the screen goes dark, so do the work thoughts. </li>
                                            <li>Wash and put away that designated coffee cup or water bottle.</li>
                                            <li> Put your lap or table desk away.</li>
                                            <li>
                                                Schedule a workout or activity for right after work to help transition your brain (bonus: a workout can help relieve any stress
                                                you’ve accumulated from the work day).
                                            </li>
                                        </ul>
                                    </ul>
                                    There are way more benefits and tips in regards to working from home than we could possibly fit in one blog post, but we hope that this was
                                    enough to point you in the right direction and get you started. If you made it through this whole post, it’s probably time for you to stand and
                                    drink some water. Seriously...stand up often and stay hydrated!
                                </p>
                                <br />
                                <p {...defns.paragraph}>
                                    If you’re looking for more work tips be sure to check out the other blog posts in our <a {...defns.resourceCenterText}>Resource Center.</a>
                                </p>
                            </div>
                        </Grid>
                        {/* <Grid {...defns.shareContainer}>
                            <Tooltip title="Share the article on LinkedIn" placement="left">
                                <div {...defns.shareImageContainer}>
                                    <img src={shareImg1} alt="" />
                                </div>
                            </Tooltip>
                            <Tooltip title="Share the article on Twitter" placement="left">
                                <div {...defns.shareImageContainer}>
                                    <img src={shareImg2} alt="" />
                                </div>
                            </Tooltip>
                            <Tooltip title="Share the article on Facebook" placement="left">
                                <div {...defns.shareImageContainer}>
                                    <img src={shareImg3} alt="" />
                                </div>
                            </Tooltip>
                            <Tooltip title="Copy the article link" placement="left">
                                <div {...defns.shareImageContainer}>
                                    <img src={shareImg4} alt="" />
                                </div>
                            </Tooltip>
                        </Grid> */}
                    </>
                ) : (
                    <>
                        <Grid {...defns.paragraphContainer}>
                            <div style={{ height: '100%' }} autoHide={false}>
                                <p {...defns.paragraph}>
                                    Working remotely will most likely be a part of the new normal in a post-pandemic world. There are many benefits to telework, but there are also
                                    a few downsides. With a little bit of prep work, you can ensure that if you’re fortunate enough to work remotely, even on a part-time basis,
                                    that you set yourself up for success at home.
                                </p>
                                <div {...defns.logoHeaderContainer}>
                                    <img {...defns.leftLogo} src={DedicatedLogo} alt="" />
                                    <h2 {...defns.secondaryHeader}>Dedicated Workspace</h2>
                                </div>
                                <p {...defns.paragraph}>
                                    Ideally, it would be great to dedicate an entire room as a work from home space, but we know that isn’t an option for all. We’re going to give
                                    you the best tips for setting up a dedicated workspace even if that space is your living room coffee table.
                                </p>
                                <br />
                                <p {...defns.paragraph}>
                                    <span style={{ fontStyle: 'italic' }}>
                                        Before getting started, we want to remind you to keep in mind that some companies have specific requirements attached to their work from
                                        home programs such as having a desk space and desk chair. Be sure to check with your company before setting up your space to ensure that you
                                        check all their telework boxes.
                                    </span>
                                </p>
                                <br />
                                <p {...defns.paragraph}>
                                    <span style={{ fontWeight: 'bold' }}> Stay Out of the Bedroom: </span>
                                    If possible, try not to make your dedicated space your bedroom. A workspace is generally a space where your mind is at it’s sharpest and most
                                    creative. Working in the bedroom can lead to interrupted sleep patterns because your brain will be wired to work mode when in it’s that space.
                                    Instead of counting sheep, you’ll be counting unfinished tasks and then the next morning you’ll be counting how much sleep you got on one hand.
                                    Not a good situation to be in. Bedrooms should be reserved for two things: sleeping and...well, use your imagination.
                                </p>
                                <br />
                                <p {...defns.paragraph}>
                                    <span style={{ fontWeight: 'bold' }}> Incorporate Triggers: </span>
                                    This is especially important if you’ll be working at the dining room table, kitchen counter, or coffee table. There has to be certain elements
                                    present that trigger your brain into knowing that it’s time to be productive for it to differentiate how it feels when you’re living in that
                                    space any other time. A few ideas could be:
                                    <ul>
                                        <li>
                                            Designate a specific coffee cup or water bottle for work. Don’t use it at any other time. When you fill’er up the creative juices will
                                            start to flow.
                                        </li>
                                        <li>
                                            Purchase a lap desk or tabletop desk to be used only during work time. That will set the tone for productivity at the beginning of the
                                            day.
                                        </li>
                                        <li>
                                            Pick a specific work scent, like an essential oil or a lovely candle.Fill a diffuser or light the candle at the start of your workday,
                                            and of course don’t use those scents during non-work hours (hopefully you can see by now that not using the trigger when not working is
                                            a pattern we’re going for here).
                                        </li>
                                    </ul>
                                </p>
                                <br />
                                <p {...defns.paragraph}>
                                    <span style={{ fontWeight: 'bold' }}>Inspirational Décor: </span>
                                    Creativity is born through inspiration. To really get the creative energy flowing within your workspace consider incorporating elements that are
                                    inspirational to you. This could be a painting, a motivational poster, pictures of your family, awards you’re proud of, sentimental gifts,
                                    heirlooms, and the list goes on. <br /> <br />
                                    Live plants are also phenomenal in a workspace (or in the home in general). Not only do <a {...defns.studiesLink}>studies</a> show that live
                                    plants in the home increases happiness, but they also keep the air cleaner, reduce stress levels, and boost productivity. They are also quite
                                    pretty to look at and will make your space more aesthetically pleasing.
                                </p>
                                <br />
                                <p {...defns.paragraph}>
                                    <span style={{ fontWeight: 'bold' }}>Keep it Tidy: </span>
                                    Try to keep your space organized and tidy. Have you ever heard the saying, “cluttered space, cluttered mind?” Well, it’s{' '}
                                    <a {...defns.trueLink}>true</a>. When your living or working space is organized, your thoughts and mind are more organized leading to less
                                    stress and anxiety, and sharper focus.
                                </p>
                                <br />
                                <p {...defns.paragraph}>
                                    <span style={{ fontWeight: 'bold' }}>Let there be Light: </span>
                                    Having proper lighting is essential in a healthy workspace. Good lighting is a mood booster, while prolonged exposure to poor lighting has been
                                    shown to increase or cause depression. Good lighting is also beneficial to reducing eye strain, which is crazy important when half our lives are
                                    spent staring at screens these days. Natural light is always best so set up shop near a window if that’s an option for you. If not, artificial
                                    lighting can do the trick too. Whatever the case make your space bright and happy.
                                </p>
                                <br />
                                <p {...defns.paragraph}>
                                    <span style={{ fontWeight: 'bold' }}>Let there be Light: </span>
                                    Sit on It (but not too long): Having a comfortable and sturdy chair for work is essential to the overall health of your entire body. Sitting in
                                    an inadequate chair for extended periods of time can lead to all kinds of chaos from back pain to headaches to fatigue, even sciatica...the list
                                    is crazy long, ya’ll. You’ll want to do a smidge of research to find the chair that is best for your needs and we found this{' '}
                                    <a {...defns.handyGuideLink}>handy guide over on Medium</a> to get you started.
                                    <br /> <br />
                                    While sitting correctly is important, do you know what’s even more important? <strong> Standing.</strong> Yes, we’re talking about the opposite
                                    of sitting now, but standing is one of the number one things you should be doing at home. <a {...defns.theySayLink}>They say</a> that sitting is
                                    the new smoking, and while that might seem a tad dramatic, they aren’t wrong. Sitting for too long can lead to blood clots, increased blood
                                    pressure and cholesterol, weight gain and other health issues. At a minimum try to stand up for a few minutes every hour, but every 30 minutes
                                    is even better. You can walk and talk on the phone or if you have the means and the space, maybe even consider a standing desk.
                                </p>

                                <div {...defns.logoHeaderContainer}>
                                    <img {...defns.leftLogo} src={WorkLogo} alt="" />
                                    <h2 {...defns.secondaryHeader}>Work/Life Balance</h2>
                                </div>
                                <p {...defns.paragraph}>
                                    These are a few of our go-to tips to make sure that when we’re working from home, we are keeping balance between what should be work and what
                                    should be home: <br />
                                    <ul>
                                        <li>
                                            <strong>Take Breaks: </strong> Just like when you’re physically in the office you are legally allowed breaks (usually two 15-minute
                                            breaks and a 30-minute lunch break, but check with your company for their guidelines).
                                        </li>
                                        <li>
                                            <strong>Get Outside: </strong> If you’re able to go outside and breathe in some sweet fresh air and soak up a little Vitamin D, you so
                                            should. Maybe take a quick walk during one of your breaks if that’s a possibility for you. Fresh air and sunshine is the ultimate stress
                                            reducer.
                                        </li>
                                        <li>
                                            <strong>Stay Hydrated: </strong> This is just good advice for always, but make sure you’re getting in the H20 during business hours for
                                            sure. Being hydrated helps your body perform at optimal levels and reduces fatigue (plus all the other benefits of water, a.k.a. the
                                            elixir of life).
                                        </li>
                                        <li>
                                            <strong>Take back Your Time: </strong> Working from home gives you back those hours of life you would normally spend commuting to and
                                            from the office. Take advantage of that precious time and do something awesome for yourself. Take that spin class that never fit into
                                            your schedule before or get a killer home workout in. Sleep in a little bit (if it won’t mess up your sleep cycle), finish reading a
                                            book, or take your dog/kids/both to the park...whatever it is that makes you feel more relaxed, more alive, more present...do that and
                                            enjoy it.
                                        </li>
                                        <li>
                                            <strong>Leave Work at Work: </strong> Just like when you’re in the office, it’s imperative to leave work at work. This can be tricky
                                            when working from home, but if you follow our tips for setting up your workspace that should make it a little easier. For your mental
                                            and physical health there needs to be a moment when you break up with your workday every day. This is similar to how we set triggers for
                                            beginning our workday. A few tricks that might work for you:
                                        </li>
                                        <ul style={{ listStyle: 'disc' }}>
                                            <li>Shut down your computer. When the screen goes dark, so do the work thoughts. </li>
                                            <li>Wash and put away that designated coffee cup or water bottle.</li>
                                            <li> Put your lap or table desk away.</li>
                                            <li>
                                                Schedule a workout or activity for right after work to help transition your brain (bonus: a workout can help relieve any stress
                                                you’ve accumulated from the work day).
                                            </li>
                                        </ul>
                                    </ul>
                                    There are way more benefits and tips in regards to working from home than we could possibly fit in one blog post, but we hope that this was
                                    enough to point you in the right direction and get you started. If you made it through this whole post, it’s probably time for you to stand and
                                    drink some water. Seriously...stand up often and stay hydrated!
                                </p>
                                <br />
                                <p {...defns.paragraph}>
                                    If you’re looking for more work tips be sure to check out the other blog posts in our <a {...defns.resourceCenterText}>Resource Center.</a>
                                </p>

                                {/* <div {...defns.shareContainer2}>
                                <Tooltip title="Share the article on LinkedIn" placement="left">
                                    <div {...defns.shareImageContainer}>
                                        <img src={shareImg1} alt="" />
                                    </div>
                                </Tooltip>
                                <Tooltip title="Share the article on Twitter" placement="left">
                                    <div {...defns.shareImageContainer}>
                                        <img src={shareImg2} alt="" />
                                    </div>
                                </Tooltip>
                                <Tooltip title="Share the article on Facebook" placement="left">
                                    <div {...defns.shareImageContainer}>
                                        <img src={shareImg3} alt="" />
                                    </div>
                                </Tooltip>
                                <Tooltip title="Copy the article link" placement="left">
                                    <div {...defns.shareImageContainer}>
                                        <img src={shareImg4} alt="" />
                                    </div>
                                </Tooltip>
                            </div> */}
                            </div>
                        </Grid>
                    </>
                )}
            </Grid>

            <hr {...defns.hr} />
            <div {...defns.backToTopContainer}>
                <div {...defns.flexSpaceBetween}>
                    <div {...defns.copyRightText}>{getCopyrightText()}</div>
                    <p
                        {...defns.backToTopText}
                        onClick={() => {
                            setTimeout(() => {
                                myRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
                            }, 100);
                        }}
                    >
                        Back to the top
                    </p>
                </div>
            </div>

            {/* <h2 {...defns.heading}>Related Content</h2>
            <Grid {...defns.cardContainer}>
                <Grid {...defns.cardSection}>
                    <div {...defns.card}>
                        <div {...defns.imageContainer}>
                            <img {...defns.img} src={cardImg1} alt="" />
                        </div>
                        <div {...defns.cardContent}>
                            <p {...defns.dateTime}>2 min read</p>
                            <h3 {...defns.cardHeading}>Remote Workstations for the Discerning Artists</h3>
                            <p {...defns.cardParagraph}>
                                Netflix is poised to become the world’s most prolific producer of visual effects and original animated content. To meet that demand, we need to
                                attract the world’s best artistic talent.{' '}
                            </p>
                        </div>
                    </div>
                </Grid>
                <Grid {...defns.cardSection}>
                    <div {...defns.card}>
                        <div {...defns.imageContainer}>
                            <img {...defns.img} src={cardImg2} alt="" />
                        </div>
                        <div {...defns.cardContent}>
                            <p {...defns.dateTime}>2 min read</p>
                            <h3 {...defns.cardHeading}>Working Remotely: A Complete Guide to Turn You Into a Pro</h3>
                            <p {...defns.cardParagraph}>
                                Working remotely is more difficult in practice than in theory. Turn to this guide with actionable advice from veteran remote workers on how to
                                handle challenges that are
                            </p>
                        </div>
                    </div>
                </Grid>
                {matchesMd ? (
                    <></>
                ) : (
                    <Grid {...defns.cardSection}>
                        <div {...defns.card}>
                            <div {...defns.imageContainer}>
                                <img {...defns.img} src={cardImg3} alt="" />
                            </div>
                            <div {...defns.cardContent}>
                                <p {...defns.dateTime}>2 min read</p>
                                <h3 {...defns.cardHeading}>Brent Potts Joins Airbnb as Vice President of Community Support</h3>
                                <p {...defns.cardParagraph}>
                                    Today we are excited to announce that Brent Potts has joined Airbnb as Vice President of Community Support. Lorem ipsum dolor sit amet.
                                </p>
                            </div>
                        </div>
                    </Grid>
                )}
            </Grid> */}
        </div>
    );
};

export default ArticleFour;
